module.exports = __webpack_public_path__ + "static/media/warning.0ccf9562.svg";